module.exports = __webpack_public_path__ + "cachable/fonts/fa-regular-400.232215c73ce36816d36c5d9ae76e38fa.eot";


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/fontawesome-pro/webfonts/fa-regular-400.eot
// module id = 335
// module chunks = 0